<div class="tip-selector">
  <app-amount-selector
    [options]="options()"
    [type]="amountSelectorType()"
    [(ngModel)]="value"
    (ngModelChange)="onTipChange($event)"
  />
</div>
